<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--portfolio details start-->

<section>
  <div class="container">
    <div class="portfolio-info">
      <div class="row align-items-center">
        <div class="col-lg-8 col-md-12 p-5">
          <div class="section-title mb-3">
            <h2 class="title mb-0">About <span>Project</span></h2>
          </div>
          <p>A successful marketing plan relies heavily on the pulling-power of advertising copy. Writing result-oriented ad copy is difficult, as it must appeal to, entice, and convince consumers. Discover how we gave this startup a fresh visual start</p>
          <ul class="list-unstyled">
            <li class="mb-2">1. Strategic Discovery</li>
            <li class="mb-2">2. Web application redesign & optimization</li>
            <li class="mb-2">3. Mobile application redesign & optimization</li>
            <li class="mb-2">4. Landing page Template</li>
            <li>5. Component-based UI-kit</li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-12 p-5">
          <ul class="portfolio-meta list-unstyled">
            <li class="mb-4"><i class="flaticon-domain"></i>  <span> Category</span> Agency</li>
            <li class="mb-4"><i class="flaticon-support-1"></i>  <span> Client</span> ThemeHt</li>
            <li><i class="flaticon-experience"></i>  <span> Release</span> March, 2020</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="p-0">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <img class="img-fluid w-100" src="images/portfolio/large/01.jpg" alt="">
      </div>
    </div>
  </div>
</section>

<!--portfolio details end-->

</div>

<!--body content end--> 
    </div>
</template>

<script>
// @ is an alias to /src

export default {
  data: function () {
        return {
            hasBanner: false,
            name: "portfolio Single",
        }
    }
};
</script>
